// extracted by extract-css-chunks-webpack-plugin
module.exports = {"center_box":"center_box-2d2syNWk"};